const values = [
  {
    icon: 'ri-shield-check-line',
    title: '品質保證',
    en: 'Quality Assurance',
    desc: '嚴選歐美認證品牌，所有代理產品均通過國際安全標準（ATEX、IECEx、CE），確保每一件設備的可靠性與耐用性。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '專業服務',
    en: 'Professional Service',
    desc: '擁有深厚工程背景的顧問團隊，提供完整的產品選型、技術諮詢與售後服務，陪伴客戶從採購到安裝每一個環節。',
  },
  {
    icon: 'ri-global-line',
    title: '國際接軌',
    en: 'Global Standards',
    desc: '深耕歐美供應鏈多年，與原廠保持直接合作關係，確保供貨穩定、交期準確，並及時引進最新產品技術與規格。',
  },
  {
    icon: 'ri-settings-3-line',
    title: '客製彈性',
    en: 'Flexible Solutions',
    desc: '針對特殊工況與客戶需求，提供客製化配置方案，協助工程師在設計階段即找到最符合現場條件的最佳解決方案。',
  },
];

export default function CoreValues() {
  return (
    <section className="w-full bg-[#f5f8fc] py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Section Title */}
        <div className="flex items-center justify-center gap-4 mb-2">
          <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
          <h2 className="text-3xl font-bold text-gray-800 tracking-wider">服務理念</h2>
          <span className="text-[#1a73b5] text-2xl leading-none">&#8942;</span>
        </div>
        <p className="text-center text-sm tracking-[0.3em] text-gray-400 uppercase mb-10">OUR VALUES</p>

        {/* Divider */}
        <div className="flex items-center mb-12">
          <div className="flex-1 h-px bg-[#1a73b5]" />
          <div className="w-2 h-2 bg-[#1a73b5] rotate-45 mx-1" />
          <div className="flex-1 h-px bg-[#1a73b5]" />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map(v => (
            <div
              key={v.title}
              className="bg-white border border-gray-100 p-6 flex flex-col items-center text-center hover:border-[#1a73b5] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1a73b5]/10 mb-4">
                <i className={`${v.icon} text-[#1a73b5] text-2xl`} />
              </div>
              <h3 className="text-base font-bold text-gray-800 mb-1">{v.title}</h3>
              <p className="text-xs text-[#1a73b5] tracking-widest uppercase mb-3">{v.en}</p>
              <p className="text-sm text-gray-500 leading-[1.9]">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
